export default function R_PieCharts() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">R_PieCharts Component</h1>
      <p>This is the R_PieCharts tutorial section.</p>
    </div>
  );
}
